export enum EntryAttachmentType {
  PerformanceAssessment = 'performanceAssessmentEntry',
  PerformanceAssessmentStudent = 'performanceAssessmentStudentEntry',
  Note = 'note',
  SupportMeasure = 'supportMeasureEntry',
  SupportMeasureProtocol = 'supportMeasureProtocolEntry',
}

export interface IEntryAttachmentTarget {
  entryType: EntryAttachmentType;
  entryId: number;
}

export enum AttachmentContentType {
  Image = 'image',
  File = 'file',
  App = 'app',
}
